import React from "react";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import Home from "../pages/home/Home";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import Reservation from "../pages/Reservation/Reservation";
import Verification from "../pages/verification/Verification";
import PersonalPage from "../pages/personalPage/PersonalPage";
import { AuthProvider } from "../contexts/AuthContext";
import { ModalProvider } from "../contexts/ModalContext";
import { Provider } from "react-redux";
import { store } from "../lib/store/store";
import { SelectedToursProvider } from "../contexts/SelectedToursContext";
import { OtpProvider } from "../contexts/OtpContext";
import { TransformedDataProvider } from "../contexts/TransformedDataContext";
import Test from "../layout/Test";
import EditBooking from "../pages/personalPage/sections/EditBooking";
import Companies from "../components/Companies";
import { HelmetProvider } from "react-helmet-async";
import NotFoundPage from "../components/NotFoundPage";
import ProtectedRoute from "../components/ProtectedRoute";

// import { OtpProvider } from "../contexts/OTPContext";

function Router() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <TransformedDataProvider>
          <AuthProvider>
            <OtpProvider>
              <SelectedToursProvider>
                <ModalProvider>
                  <BrowserRouter>
                    <div className="leap-bg-[#1D2346]">
                      <Navbar />

                      <Routes>
                        <Route path="*" element={<NotFoundPage />} />
                        <Route path="/" element={<Home />} />
                        <Route path="/reservation" element={<Reservation />} />
                        <Route
                          path="/verification"
                          element={
                            <ProtectedRoute element={<Verification />} />
                          }
                        />
                        <Route
                          path="/personal-page"
                          element={<PersonalPage />}
                        />
                        <Route
                          path="/personal-page/update"
                          element={<EditBooking />}
                        />
                      </Routes>
                      <Footer />
                    </div>
                  </BrowserRouter>
                </ModalProvider>
              </SelectedToursProvider>
            </OtpProvider>
          </AuthProvider>
        </TransformedDataProvider>
      </HelmetProvider>
    </Provider>
  );
}

export default Router;
